import { EJ as EJModule } from '../../CIMSModule/instances'
import { CIMSPage } from '../../cimsPage'
import { Permission } from '../../permission'
import { RoleTemplateItem } from '../RoleTemplateItem'

const EJ = 'Engineering Judgement'
const EJWF = `${EJ}s workflow`

export const EJAdmin = new RoleTemplateItem({
  id: '13005e3e-ab37-4dc2-8121-0fb9d4e69d4f',
  name: `${EJ} Admin`,
  description: `Gives users access to all permissions within the ${EJWF}`,
  module: EJModule,
  permissionItems: Permission.findByModule(EJModule),
})

export const EJIssuer = new RoleTemplateItem({
  id: '51c42b3e-3750-42c1-9ab0-c28e4ed82676',
  name: `${EJ} Issuer`,
  description: `Gives users the ability to issue an ${EJ}`,
  module: EJModule,
  permissionItems: [
    ...Permission.findByPage(CIMSPage.EJLog),
    Permission.ViewEJNotification,
    Permission.ViewEJQuickLink,
    Permission.ViewEJType,
  ],
})

export const EJViewOnly = new RoleTemplateItem({
  id: '26f1746e-104d-4629-b83c-10e5418b80e5',
  name: `${EJ} View Only`,
  description: `Allows users to View the ${EJWF} but not make any changes`,
  module: EJModule,
  permissionItems: [
    Permission.ViewEngineeringJudgement,
    Permission.ViewEJNotification,
  ],
})

export type EJRoleTemplateItem =
  | typeof EJAdmin
  | typeof EJIssuer
  | typeof EJViewOnly
